import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';
/**
 * Isabela PhilRice drone COGs.
 *
 * **NDVI + ortho** use Titiler `WebMercatorQuad` XYZ tiles (`bidx=1,2,3` RGB). Layer-list thumbnails use
 * `/api/preview` with the same band hints.
 */

export const ISABELA_PHILRICE_COG_URLS = {
  ndvi: 'https://digisaka.s3.amazonaws.com/Leads+Agri_Drone+Outputs/Isabela_Philrice/Philrice+Isabela_NDVI.tif',
  ortho: 'https://digisaka.s3.amazonaws.com/Leads+Agri_Drone+Outputs/Isabela_Philrice/Philrice+Isabela_Ortho.tif',
} as const;

export type IsabelaPhilriceKind = keyof typeof ISABELA_PHILRICE_COG_URLS;

const PREVIEW_BASE = DIGISAKA_API_ORIGIN + '/api/preview';

const TITILER_TILE_BASE = DIGISAKA_API_ORIGIN + '/api/tiles/WebMercatorQuad/{z}/{x}/{y}@2x.png';

/** WebMercatorQuad XYZ — 3-band RGB (NDVI + ortho). */
export function buildIsabelaPhilriceTileUrl(kind: IsabelaPhilriceKind): string {
  const u = `${TITILER_TILE_BASE}?url=${encodeURIComponent(ISABELA_PHILRICE_COG_URLS[kind])}`;
  return `${u}&bidx=1&bidx=2&bidx=3&resampling=lanczos`;
}

/**
 * Layer-list thumbnails — match Titiler params used on the map.
 */
export function buildIsabelaPhilricePreviewUrl(kind: IsabelaPhilriceKind, maxSize = 160): string {
  const url = ISABELA_PHILRICE_COG_URLS[kind];
  const q = `url=${encodeURIComponent(url)}`;
  return `${PREVIEW_BASE}?${q}&max_size=${maxSize}&bidx=1&bidx=2&bidx=3`;
}
